module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI2IiBoZWlnaHQ9IjE1OSIgdmlld0JveD0iMCAwIDEyNiAxNTkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNNzMuNzQ1OCAxNTguMzZIMTAzLjkyVjEyNy43NThIMTI1Ljc0OFYxMDIuNzJIMTAzLjkyVjBIODAuMzc5OEwwLjM0Mzc1IDEwN1YxMjcuNzU4SDczLjc0NThWMTU4LjM2Wk0zNS44Njc4IDEwMy41NzZMNzUuMDI5OCA1MS4zNkw3NC42MDE4IDEwMy41NzZIMzUuODY3OFoiIGZpbGw9IiMyMDIwMjAiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/4.svg
// module id = OX62
// module chunks = 12